<template>
  <ContentWrap>
    <el-form ref="queryFormRef" :inline="true" :model="queryParams" class="-mb-15px" label-width="68px">
      <el-form-item label="创建时间" prop="createTime">
        <el-date-picker
          v-model="queryParams.createTime"
          class="!w-240px"
          end-placeholder="结束日期"
          start-placeholder="开始日期"
          type="daterange"
          value-format="YYYY-MM-DD HH:mm:ss"
        />
      </el-form-item>
      <el-form-item label="拼团状态" prop="status">
        <el-select v-model="queryParams.status" class="!w-200px" clearable placeholder="全部">
          <el-option
            v-for="dict in getIntDictOptions(DICT_TYPE.PROMOTION_COMBINATION_RECORD_STATUS)"
            :key="dict.value"
            :label="dict.label"
            :value="dict.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="handleQuery"><Icon class="mr-5px" icon="ep:search" />搜索</el-button>
        <el-button @click="resetQuery"><Icon class="mr-5px" icon="ep:refresh" />重置</el-button>
        <el-button @click="goBack">返回</el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-table v-loading="loading" :data="list" stripe>
      <el-table-column align="center" label="编号" prop="id" min-width="70" />
      <el-table-column align="center" label="昵称" prop="nickname" min-width="100" />
      <el-table-column align="center" label="开团团长" min-width="100">
        <template #default="{ row }">
          {{ row.headId ? list.find((item) => item.id === row.headId)?.nickname : row.nickname }}
        </template>
      </el-table-column>
      <el-table-column :formatter="dateFormatter" align="center" label="开团时间" prop="startTime" width="180" />
      <el-table-column label="拼团商品" min-width="220" show-overflow-tooltip>
        <template #default="{ row }">
          <el-image :src="row.picUrl" class="mr-5px h-30px w-30px align-middle" />
          <span class="align-middle">{{ row.spuName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="几人团" prop="userSize" min-width="80" />
      <el-table-column align="center" label="参与人数" prop="userCount" min-width="90" />
      <el-table-column :formatter="dateFormatter" align="center" label="参团时间" prop="createTime" width="180" />
      <el-table-column align="center" label="拼团状态" prop="status" min-width="120">
        <template #default="scope">
          <dict-tag :type="DICT_TYPE.PROMOTION_COMBINATION_RECORD_STATUS" :value="scope.row.status" />
        </template>
      </el-table-column>
    </el-table>
    <Pagination :total="total" v-model:page="queryParams.pageNo" v-model:limit="queryParams.pageSize" @pagination="getList" />
  </ContentWrap>
</template>

<script setup lang="ts">
import { getCombinationRecordPage } from '@/api/merchant/promotion'
import { DICT_TYPE, getIntDictOptions } from '@/utils/dict'
import { dateFormatter } from '@/utils/formatTime'

defineOptions({ name: 'MerchantCombinationRecord' })

const router = useRouter()
const loading = ref(true)
const total = ref(0)
const list = ref<any[]>([])
const queryParams = reactive({
  pageNo: 1,
  pageSize: 10,
  status: undefined as number | undefined,
  createTime: [] as string[]
})
const queryFormRef = ref()

const getList = async () => {
  loading.value = true
  try {
    const data = await getCombinationRecordPage(queryParams)
    list.value = data.list
    total.value = data.total
  } finally {
    loading.value = false
  }
}

const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}

const resetQuery = () => {
  queryFormRef.value?.resetFields()
  handleQuery()
}

const goBack = () => router.push({ name: 'MerchantPromotion' })

onMounted(() => {
  getList()
})
</script>
